import { createMetaInfoObject } from '~/lib'
export const useShopwareMetaTags = (entity: any) => {
  useSeoMeta(
    createMetaInfoObject([
      ['title', `${entity.translated.metaTitle ? entity.translated.metaTitle : entity.translated.name} | Careum`],
      [
        'description',
        entity.translated.metaDescription ? entity.translated.metaDescription : entity.translated.description,
      ],
      ['og:title', entity.translated.metaTitle ? entity.translated.metaTitle : entity.translated.name],
      [
        'og:description',
        entity.translated.metaDescription ? entity.translated.metaDescription : entity.translated.description,
      ],
      ['robots', 'index, follow'],
    ]),
  )
}
